<template>
    <div
        v-commonButtonTest="formAdList.length > 0 ? formAdList[0].button : {}"
        :class="pageParams.pClient === '17'?'banner-form wrapperClass banner-form-waijiao':'banner-form wrapperClass'"
        :style="{backgroundImage:`url(${formAdList.length > 0 ? formAdList[0].icon : defaultBgi})`}"
    >
        <div class="form-location" @click.stop="void 0">
            <Form
                :cat-name="FROM_CONFIG[pageParams.pClient].catName"
                :form-data="formList"
                :form-item-class="isSmall ? 'form-item-wrapper--small' : 'form-item-wrapper--default'"
                :operate-width="isSmall ? '180px' : '237px'"
                label-width="0px"
                :item-hieght="pageParams.pClient=='17'?'44px':isSmall ? '29px' : '38px'"
                :source-id="pageParams.pClient == 12 ? formLeadsId : sourceParams.pageSource"
                :other-params="{}"
                :valid-event="false"
                :oriurlprop="oriurlprop"
                @form-submit="handleButtonHaobo"
            >
                <template v-slot:button>
                    <button
                        :class="['form-button', isSmall && 'form-button--small']"
                    >
                        {{formData.buttonText}}
                    </button>
                </template>
            </Form>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import {getPClientAndPageId} from '~/util/liuxue';
import api from '~/api';
import Form from '~/components/liuxue/common/Form copy';
import projectConfig from '~/environment.js';
import {getCookReturnExt} from '~/util/yiliaoSdk';
import {config, ready, getValue} from '@umeng/source-sdk';
// import TAOJING_SOURCE from '@/constants/sourceMap';
import {homepage} from '@/constants/haboEvents';
import urlUtils from '~/util/url';
import {getHaboEventId, mobileInput} from '~/constants/haboEvents';


const {
    EVENT_ID_INPUT_TELE,
    EVENT_ID_TELE_SUBMIT,
    EVENT_ID_TELE_SUNMIT_SUCCESS,
    EVENT_ID_WAIJIAO_INPUT_TELE,
    EVENT_ID_WAIJIAO_TELE_SUBMIT,
    EVENT_ID_WAIJIAO_TELE_SUNMIT_SUCCESS
} = homepage;

export default {
    name: 'LeaveFrom',
    components: {
        Form
    },
    props: {
        wrapperClass: {
            type: String,
            default() {
                return '';
            }
        },
        isSmall: {
            type: Boolean,
            default() {
                return false;
            }
        },
        // 表单
        formData: {
            type: Object,
            default() {
                return {};
            }
        },
        formAdList: {
            type: Array,
            default() {
                return [];
            }
        },
        from: {
            type: String,
            default() {
                return '';
            }
        },
        defaultBgi: {
            type: String,
            default() {
                return 'https://i.gsxcdn.com/1976191964_878q2521.png';
            }
        },
        oriurlprop: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return ({
            configData: {moduleCode: 'pc_website_secondPage_form'},
            formLeadsId: '',
            FROM_CONFIG: {
                6: {catName: '公职', otherParams: {}},
                7: {catName: '留学咨询服务', otherParams: {}},
                12: {catName: '考研', otherParams: {level3CategoryId: 85}},
                16: {catName: '财经', otherParams: {}},
                17: {catName: '语言培训-英语-综合', otherParams: {}},
            }
        });
    },
    computed: {
        ...mapState({
            TAOJIN_SOURCE: state => state.TAOJIN_SOURCE,
            pageParams: state => state.pageParams,
            sourceParams: state => state.sourceParams,
        }),
        formList() {
            // 手机号聚焦事件
            const handleFocus = () => {
                const {pClient, pageId} = this.pageParams;
                const haboId = getHaboEventId(pClient, pageId, mobileInput);
                this.$habo.haboClickReport(haboId);
                this.generateLeadsId();
            };
            this.formData.data?.forEach(item => {
                if (item.prop === 'mobile') {
                    item.onFocus = handleFocus;
                }
            });
            return this.formData.data || [];
        }
    },
    mounted() {
        if (!this.formData.data) {
            this.getOneModule();
        }
        this.formLeadsId = getCookReturnExt('yiliaoSourceLeads') || '';
    },
    methods: {
        handleButtonHaobo() {
            if (this.pageParams.pClient === '17') {
                this.$habo.haboClickReport(EVENT_ID_WAIJIAO_TELE_SUBMIT);
                this.$habo.haboClickReport(EVENT_ID_WAIJIAO_TELE_SUNMIT_SUCCESS);
            }
            else {
                this.$habo.haboClickReport(EVENT_ID_TELE_SUBMIT);
                this.$habo.haboClickReport(EVENT_ID_TELE_SUNMIT_SUCCESS);
            }

        },
        // 生成leadsId
        generateLeadsId() {

            const query = urlUtils.parseUrl(location.href);

            let calendarSource = this.TAOJIN_SOURCE.CALENDAR_FORM;
            if (this.from === 'calendar') {
                calendarSource = query?.cmsCategoryId === '439'
					? this.TAOJIN_SOURCE.CALENDAT_FORM_439
					: (
						query?.cmsCategoryId === '442'
							? this.TAOJIN_SOURCE.CALENDAT_FORM_442
							: calendarSource
                );
            }

            let source = '';
            switch (this.from) {
                case 'home': source = this.TAOJIN_SOURCE.HOME_FORM; break;
                case 'categoty': source = this.TAOJIN_SOURCE.CATEGORY_FORM; break;
                case 'information': source = this.TAOJIN_SOURCE.INFORMATION_FORM; break;
                case 'information-detail': source = this.TAOJIN_SOURCE.INFORMATION_DETAIL_FORM; break;
                case 'calendar': source = calendarSource; break;
                default: source = this.TAOJIN_SOURCE.HOME_FORM; break;
            }
            const sourceLeads = this.$sourceLeads;
            const params = {
                sourceId: source,
                entrancePageId: window.location.href,
                businessMark: this.getCookie('GID'),
                pageType: 2,
                clientType: 0,
                env: projectConfig.env.env === 'master' ? 'prod' : 'test',
            };
            if (sourceLeads) {
                params.parentLeadsId = sourceLeads;
            }
            const readyParams = {source, parentLeadsId: sourceLeads};
            config(params);
            ready(readyParams, leadsId => {
                console.log('二级source', source, '二级leadsId', leadsId, '一级leadsId', sourceLeads);
                this.formLeadsId = leadsId || getValue(readyParams);
            });
        },
        // （考研接口）
        getOneModule() {
            const {pClient, pageId} = getPClientAndPageId(location.host, this.$route.path);
            const getUrl = `${api.kaoyan.secondForm}?pageId=${pageId}&pClient=${pClient}&endCode=pc_website_secondPage_form_${pClient}_1`;
            this.$axios.$get(getUrl).then(res => {
                if (res.code === 0) {
                    const {moduleCode, endCode, moduleConfig, moduleData} = res.data;
                    this.formData = moduleConfig.formData;
                    this.formAdList = moduleData.formAdList;
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.banner-form {
    width: 100%;
    height: 202px;
    border-radius: 8px;
    background-color: #FFF5F5;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    .form-location {
        width: 100%;
        position: absolute;
        bottom: 20px;
        left: 0;

        /deep/ .form-item-wrapper--small {
            margin-left: -20px;
            margin-bottom: -5px;

            .el-input__inner {
                border-radius: 16.0109px !important;
                height: 29px !important;
                font-size: 12px;
            }
        }

        /deep/ .form-item-wrapper--default {
            margin-left: -20px;
            margin-bottom: -5px;

            .el-input__inner {
                border-radius: 21.11px !important;
                height: 38px !important;
                font-size: 12px;
                border-color: #E3E3E3;
            }
        }
    }

    .form-button {
        width:237px;
        height: 40px;
        background: #FF443D;
        border-radius: 21px;
        border-width: 0px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        box-shadow: 0px 18px 18px -12px #FF443D67;

        &:hover {
            background: #f1332b;
        }
    }

    .form-button--small {
        width: 180px;
        height: 30px;
        border-radius: 16.0109px;
        font-size: 12px;
    }

    /deep/ .el-input {
        background: unset !important;
    }
    /deep/ .el-input__inner {
        background: #EFF2F8 !important;
    }

    /deep/ .el-form-item__error {
        font-weight: 400;
        font-size: 10px;
        line-height: 14px;
        color: #FF443D;
        padding-top: 1px;
    }
}
.banner-form-waijiao{
    height: 303px;
}
</style>
